import moment from "moment";
export const handleDateChange = (value) => {
  if (value.length === 8 || value.length === 9) {
    if (value.indexOf("/") !== -1) {
      let dateArr = value.split("/");
      if (dateArr.length === 3) {
        if (
          (dateArr[0].length === 1 || dateArr[0].length === 2) &&
          (dateArr[1].length === 1 || dateArr[1].length === 2) &&
          dateArr[2].length > 0 &&
          dateArr[2].length < 5
        ) {
          if (dateArr[0].length === 1) value = "0" + dateArr[0];
          else value = dateArr[0];
          if (dateArr[1].length === 1) value = value + "0" + dateArr[1];
          else value = value + dateArr[1];
          value = value + dateArr[2];
        } else {
          return "";
        }
      } else {
        return "";
      }
    }
    value = value.replace(/[^0-9]/g, "").trim();
    value = value.replace(/^(\d{2})/, "$1/");
    value = value.replace(/\/(\d{2})/, "/$1/");
    value = value.replace(/(\d)\/(\d{4}).*/, "$1/$2");
  }

  if (value.length === 10 && moment(value, "MM/DD/YYYY", true).isValid()) {
    return value;
  }
  if (
    value === "99/99/9999" ||
    (value.length === 10 && !moment(value, "MM/DD/YYYY", true).isValid())
  ) {
    return "";
  }
  return value;
};
export const formatExcelNumber=(value)=>{
  if(value){
    let val=value.toString()
    const len =val.length;
    if (len < 4) return val;
    if (len < 7) {
      return `${val.slice(0, 3)}-${val.slice(3)}`;
    }
    return `${val.slice(0, 3)}-${val.slice(
      3,
      6
    )}-${val.slice(6)}`;
  }
}

export const formatPhoneNumber =(value) =>{
  if (!value) return value;
  const phoneNumber = value.replace(/[^\d]/g, "");
  const phoneNumberLength = phoneNumber.length;
  if (phoneNumberLength < 4) return phoneNumber;
  if (phoneNumberLength < 7) {
    return `${phoneNumber.slice(0, 3)}-${phoneNumber.slice(3)}`;
  }
  return `${phoneNumber.slice(0, 3)}-${phoneNumber.slice(
    3,
    6
  )}-${phoneNumber.slice(6)}`;
}
